import React from "react";
import BendreJewellers from "../assets/case-studies/bendre-jewellers-web-cs.png";

export default function BendreJewellersCaseStudy() {
  return (
    <div className="cs-pages">
      <img src={BendreJewellers} alt="Bendre Jewellers" width={"80%"} />
    </div>
  );
}
